import { FingerprintCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconFingerprintCircle12Line = createIcon(
  FingerprintCircle,
  12,
  "Line"
);
export const IconFingerprintCircle16Line = createIcon(
  FingerprintCircle,
  16,
  "Line"
);
export const IconFingerprintCircle20Line = createIcon(
  FingerprintCircle,
  20,
  "Line"
);
export const IconFingerprintCircle24Line = createIcon(
  FingerprintCircle,
  24,
  "Line"
);
export const IconFingerprintCircle32Line = createIcon(
  FingerprintCircle,
  32,
  "Line"
);
export const IconFingerprintCircle48Line = createIcon(
  FingerprintCircle,
  48,
  "Line"
);
export const IconFingerprintCircle64Line = createIcon(
  FingerprintCircle,
  64,
  "Line"
);
